import React from 'react';
import { FormikValues, connect } from 'formik';
import {
    QualityDetailRow,
    QualityFormChangeHandler,
} from '~/components/Patient/Quality/QualityGapForm';
import { enumValue, initQualityExistingAnswers } from '~/util';

export interface QualityActionRowProps {
    measure: QualityMeasureType;
    submissionAnswer?: SubmissionAnswerType;
    handleFormInputChange: QualityFormChangeHandler;
    readOnly: boolean;
    isSingle: boolean;
    statusFilter: number;
    formik: FormikValues;
}
function QualityActionRowComponent({
    measure,
    submissionAnswer,
    handleFormInputChange,
    readOnly,
    isSingle,
    statusFilter,
    formik,
}: QualityActionRowProps) {
    const init = React.useRef(true);
    React.useEffect(() => {
        if (!init.current) return;
        if (statusFilter === enumValue(['gap', 'status', 'Addressed'])) {
            // Prevent showing new submission_answer when filtering by Addressed status
            init.current = false;
            return;
        }
        const answers = initQualityExistingAnswers(
            submissionAnswer,
            measure.quality_measure_details,
            isSingle
        );
        Object.entries(answers).forEach(([key, value]) => {
            handleFormInputChange(key, value); // updates parent state so Formik can update initialValues
        });
        init.current = false;
    }, [
        measure.quality_measure_details,
        submissionAnswer,
        isSingle,
        handleFormInputChange,
        statusFilter,
    ]);

    return measure.quality_measure_details
        ?.sort((qgmd1, qgmd2) => {
            return qgmd1.sub_sequence - qgmd2.sub_sequence;
        })
        .map((detail) => (
            <QualityDetailRow
                key={detail.id}
                detail={detail}
                submissionAnswer={submissionAnswer}
                readOnly={readOnly}
                checkboxId={`quality_measure_detail_${detail.id}_${detail.system_id}_checked`}
                formik={formik}
            />
        ));
}

export const QualityActionRow = connect(QualityActionRowComponent);
